<template>
  <div id="app" class="flex flex-col items-center justify-center w-screen h-screen gap-5 bg-black">
    <span style="font-size: 100px">{{ ghost }}</span>
    <div style="font-size: 40px" class="text-concrete whitespace-nowrap flex flex-col px-4 font-medium text-center">
      <span>App is unavailable</span>
      <span style="font-size: 22px">Contact App Owner for details</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 't-app-unpublished',
    data() {
      return {
        emojis: ['👻', '😨', '😱', '🙀', '😩', '😮', '😰', '😟', '🤫', '😒', '🙄', '☹️', '😳', '😭']
      }
    },
    computed: {
      ghost() {
        return this.emojis[Math.floor(Math.random() * this.emojis.length)]
      }
    }
  }
</script>
